export const Illustration = () => {
  return (
    <div className="container illustration">
      <svg width="690" height="487" viewBox="0 0 690 487" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="illustration">
          <rect
            id="bg"
            x="20.495"
            y="103.495"
            width="649.01"
            height="331.01"
            fill="var(--color-illustration-white)"
            stroke="var(--color-illustration-black)"
            strokeWidth="0.99"
          />
          <g id="text">
            <g id="text_2">
              <rect
                id="Rectangle 1"
                x="71"
                y="154"
                width="149"
                height="43"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
                stroke="var(--color-illustration-light-green)"
                strokeWidth="2"
              />
              <rect
                id="Rectangle 5"
                x="233"
                y="153"
                width="83"
                height="45"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
              />
              <rect
                id="Rectangle 3"
                x="328"
                y="153"
                width="42"
                height="45"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
              />
              <rect
                id="Rectangle 4"
                x="382"
                y="153"
                width="143"
                height="45"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
              />
              <rect
                id="Rectangle 2"
                x="537"
                y="153"
                width="83"
                height="45"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
              />
            </g>
            <g id="text_3">
              <rect
                id="Rectangle 1_2"
                x="70"
                y="222"
                width="83"
                height="45"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
              />
              <rect
                id="Rectangle 2_2"
                x="165"
                y="222"
                width="109"
                height="45"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
              />
              <rect
                id="Rectangle 3_2"
                x="286"
                y="222"
                width="125"
                height="45"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
              />
              <rect
                id="Rectangle 4_2"
                x="423"
                y="222"
                width="64"
                height="45"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
              />
              <rect
                id="Rectangle 5_2"
                x="500"
                y="223"
                width="86"
                height="43"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
                stroke="var(--color-illustration-light-orange)"
                strokeWidth="2"
              />
            </g>
            <g id="text_4">
              <rect
                id="Rectangle 1_3"
                x="70"
                y="291"
                width="135"
                height="45"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
              />
              <rect
                id="Rectangle 3_3"
                x="218"
                y="292"
                width="106"
                height="43"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
                stroke="var(--color-illustration-light-blue)"
                strokeWidth="2"
              />
              <rect
                id="Rectangle 4_3"
                x="337"
                y="291"
                width="38"
                height="45"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
              />
              <rect
                id="Rectangle 2_3"
                x="387"
                y="291"
                width="163"
                height="45"
                fill="var(--color-illustration-black)"
                fillOpacity="0.07"
              />
            </g>
          </g>
          <g id="bubble-03">
            <g id="bubble">
              <path
                id="bubble_2"
                d="M542.839 89.7814L481.839 89.635C449.804 89.5581 423.772 115.465 423.696 147.5C423.619 179.536 449.526 205.568 481.561 205.644L512.193 205.718L512.332 205.84L540.113 230.185L540.171 205.785L542.561 205.791C574.596 205.868 600.628 179.961 600.705 147.925C600.782 115.89 574.874 89.8583 542.839 89.7814Z"
                fill="var(--color-illustration-light-grey)"
                stroke="var(--color-illustration-black)"
                strokeWidth="0.99"
              />
              <g id="Group 5">
                <path
                  id="Vector"
                  d="M522.747 116.707C522.41 115.96 521.879 115.317 521.21 114.845C520.54 114.373 519.757 114.089 518.94 114.022C518.123 113.956 517.304 114.11 516.567 114.468C515.83 114.825 515.202 115.374 514.75 116.057L480.6 168.462C480.159 169.127 479.899 169.894 479.846 170.689C479.793 171.485 479.948 172.28 480.296 172.997C480.644 173.714 481.174 174.328 481.831 174.778C482.489 175.228 483.253 175.499 484.048 175.563L543.435 180.391C544.229 180.456 545.027 180.312 545.749 179.974C546.471 179.636 547.092 179.116 547.552 178.464C548.011 177.813 548.292 177.053 548.368 176.26C548.444 175.466 548.312 174.667 547.985 173.94L522.747 116.707Z"
                  stroke="var(--color-illustration-light-orange)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_2"
                  d="M515.598 155.135L517.269 134.578"
                  stroke="var(--color-illustration-light-orange)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_3"
                  d="M514.67 166.557C514.039 166.505 513.569 165.952 513.621 165.322C513.672 164.691 514.225 164.221 514.855 164.273"
                  stroke="var(--color-illustration-light-orange)"
                  strokeWidth="2"
                />
                <path
                  id="Vector_4"
                  d="M514.67 166.557C515.301 166.608 515.853 166.138 515.905 165.507C515.956 164.877 515.486 164.324 514.855 164.272"
                  stroke="var(--color-illustration-light-orange)"
                  strokeWidth="2"
                />
              </g>
            </g>
          </g>
          <g id="bubble-02">
            <g id="bubble_3">
              <path
                id="Union"
                d="M278.84 466.638L217.84 466.784C185.805 466.861 159.773 440.954 159.696 408.919C159.619 376.883 185.527 350.851 217.562 350.775L248.193 350.701L248.333 350.579L276.113 326.234L276.172 350.634L278.562 350.628C310.597 350.551 336.629 376.458 336.706 408.494C336.782 440.529 310.875 466.561 278.84 466.638Z"
                fill="var(--color-illustration-light-grey)"
                stroke="var(--color-illustration-black)"
                strokeWidth="0.99"
              />
              <g id="Group 7">
                <path
                  id="Vector_5"
                  d="M234.632 426.534L228.521 428.919C225.828 429.932 222.844 429.842 220.216 428.67C217.589 427.497 215.529 425.336 214.484 422.655C213.439 419.975 213.493 416.99 214.634 414.348C215.775 411.707 217.911 409.621 220.579 408.544L226.69 406.159L234.632 426.534Z"
                  stroke="var(--color-illustration-light-blue)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_6"
                  d="M234.632 426.535C246.583 421.871 259.647 420.848 272.179 423.595L276.062 424.446L258.583 379.623L256.305 382.881C248.943 393.394 238.635 401.493 226.679 406.159L234.632 426.535Z"
                  stroke="var(--color-illustration-light-blue)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_7"
                  d="M275.676 392.993L278.858 401.143"
                  stroke="var(--color-illustration-light-blue)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_8"
                  d="M277.267 385.541L285.342 406.219"
                  stroke="var(--color-illustration-light-blue)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_9"
                  d="M234.632 426.535C235.673 429.204 237.247 431.634 239.257 433.675C241.268 435.717 243.672 437.328 246.325 438.411"
                  stroke="var(--color-illustration-light-blue)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
          </g>
          <g id="bubble-01">
            <g id="bubble_4">
              <path
                id="bubble_5"
                d="M134.5 20.4951H195.5C227.535 20.4951 253.505 46.4647 253.505 78.5C253.505 110.535 227.535 136.505 195.5 136.505H164.868L164.729 136.627L136.89 160.905V136.505H134.5C102.465 136.505 76.4951 110.535 76.4951 78.5C76.4951 46.4647 102.465 20.4951 134.5 20.4951Z"
                fill="var(--color-illustration-light-grey)"
                stroke="var(--color-illustration-black)"
                strokeWidth="0.99"
              />
              <g id="Group 4">
                <path
                  id="Vector_10"
                  d="M171.467 110.229L140.502 86.7096C123.545 72.4571 143.888 40.5092 167.366 62.8959C186.644 36.8048 212.084 64.8909 197.926 81.7344L171.467 110.229Z"
                  stroke="var(--color-illustration-light-green)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_11"
                  d="M186.355 67.274L166.373 88.9141L155.876 80.959"
                  stroke="var(--color-illustration-light-green)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
